import { DriversType, CategoriesType } from "@/types/settings/drivers";
import Storage from "@/services/storage";
import { StorageConstants } from "@/enums/storage.enum";
import TeamsInterface from "@/interface/business/teams.interface";

class Team implements TeamsInterface {
  id: string = "";
  name: string = "";
  drivers?: Array<DriversType> = [];
  created_at?: string = "";
  updated_at?: string = "";
  locations?: string = "";
  selected?: boolean = false;

  public static module_name = "delivery/team";

  constructor(data: CategoriesType) {
    if (data) {
      this.id = data.id;
      this.name = data.name || "";
      this.drivers = data?.drivers || [];
      this.created_at = data?.created_at || "";
      this.updated_at = data?.updated_at || "";
      this.prepareLocations(data);
    }
  }

  /**
   * map the locations name to the location id
   * @param data
   * @private
   */
  private prepareLocations(data) {
    const locationsList = Storage.get(StorageConstants.LOCATIONS);
    this.locations = data.locations?.flatMap((id) => locationsList.find((location) => location.id === id)) || '' ;
  }
}

export default Team;
